import React from 'react'
import { Link } from 'react-router-dom';
import { formatDbDateWithoutTime } from '../../utils/dateFormater';
import Img2 from "../images/orders-image.png"

const Orders = ({ orders, user }) => {

    const handleClassName = (orderStatus) => {
        if (orderStatus === "ORDERED") return "text-emerald-700 bg-emerald-50 border-emerald-200/50";
        if (orderStatus === "REVIEWED") return "text-pink-700 bg-pink-50 border-pink-200/50";
        if (orderStatus === "DELIVERED") return "text-amber-700 bg-amber-50 border-amber-200/50";
        if (orderStatus === "SUSPENDED") return "text-rose-700 bg-rose-50 border-rose-200/50";
        if (orderStatus === "ON_HOLD") return "text-blue-700 bg-blue-50 border-blue-200/50";
        if (orderStatus === "REFUNDED") return "text-emerald-700 bg-emerald-50 border-emerald-200/50";
        if (orderStatus === "COMMISSIONED") return "text-slate-700 bg-slate-50 border-slate-200/50";
        if (orderStatus === "COMPLETED") return "text-purple-700 bg-purple-50 border-purple-200/50";
        if (orderStatus === "CANCELLED") return "text-rose-700 bg-rose-50 border-rose-200/50";
        if (orderStatus === "REVIEW_DELETED") return "text-rose-700 bg-rose-50 border-rose-200/50";
        if (orderStatus === "SYSTEM_CANCELLED") return "text-rose-700 bg-rose-50 border-rose-200/50";
        return "text-zinc-700 bg-zinc-50 border-zinc-200/50";
    }

    const getStatusIcon = (status) => {
        if (status === "ORDERED") return "fa-cart-shopping";
        if (status === "REVIEWED") return "fa-star";
        if (status === "DELIVERED") return "fa-truck";
        if (status === "COMPLETED") return "fa-check-circle";
        if (status === "CANCELLED" || status === "SYSTEM_CANCELLED") return "fa-xmark-circle";
        return "fa-circle";
    }

    return (
        <div className="bg-white rounded-2xl p-6 lg:p-8">
            {/* Header */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-sky-500 to-sky-600 rounded-xl flex items-center justify-center shadow-md shadow-sky-500/20">
                        <i className="fa-solid fa-cart-shopping text-white text-xl"></i>
                    </div>
                    <div>
                        <h2 className="text-xl font-bold text-zinc-900">Recent Orders</h2>
                        <p className="text-sm text-zinc-500 mt-0.5">Here is the list of your 5 most recent orders.</p>
                    </div>
                </div>
                
                <div className="flex items-center gap-4 self-stretch md:self-auto justify-between md:justify-end">
                    <img src={Img2} alt="" className="h-10 object-contain hidden md:block" />
                    <Link to={`/orders/all-orders`} className="inline-flex items-center gap-2 bg-white border border-zinc-200 hover:border-zinc-300 shadow-sm hover:shadow-md transition-all px-4 py-2.5 rounded-xl text-sm font-bold text-zinc-700 group">
                        View All Orders
                        <i className="fa-solid fa-arrow-right text-zinc-400 group-hover:translate-x-1 transition-transform"></i>
                    </Link>
                </div>
            </div>

            {/* Table */}
            <div className="w-full overflow-x-auto border border-zinc-100 rounded-xl">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-zinc-50/50">
                            <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider w-12 whitespace-nowrap"></th>
                            <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider whitespace-nowrap">Order ID</th>
                            <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider whitespace-nowrap">Product ID</th>
                            <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider whitespace-nowrap">Status</th>
                            <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider text-center whitespace-nowrap">PM Commission</th>
                            {user?.role !== "PM" && (
                                <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider text-center whitespace-nowrap">Portal Commission</th>
                            )}
                            <th className="px-5 py-5 text-sm font-bold text-zinc-500 uppercase tracking-wider text-right whitespace-nowrap">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders?.length > 0 ? (
                            orders.map((order, index) => (
                                <tr key={index} className="border-t border-zinc-100 hover:bg-zinc-50/30 transition-colors">
                                    <td className="px-5 py-5 whitespace-nowrap">
                                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${handleClassName(order?.status)} border`}>
                                            <i className="fa-solid fa-cart-arrow-down text-base"></i>
                                        </div>
                                    </td>
                                    <td className="px-5 py-5 text-base font-bold text-zinc-900 whitespace-nowrap">
                                        #{order?.id}
                                    </td>
                                    <td className="px-5 py-5 text-base font-medium text-zinc-500 whitespace-nowrap">
                                        {order?.product_id}
                                    </td>
                                    <td className="px-5 py-5 whitespace-nowrap">
                                        <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-black border ${handleClassName(order?.status)} whitespace-nowrap uppercase tracking-wide`}>
                                            <i className={`fa-solid ${getStatusIcon(order?.status)}`}></i>
                                            {order?.status.replaceAll("_", " ")}
                                        </span>
                                    </td>
                                    <td className="px-5 py-5 text-base font-black text-zinc-900 text-center whitespace-nowrap">
                                        Rs. {order?.pm_commission_amount || 0}
                                    </td>
                                    {user?.role !== "PM" && (
                                        <td className="px-5 py-5 text-base font-black text-zinc-900 text-center whitespace-nowrap">
                                            Rs. {order?.portal_commission_amount || 0}
                                        </td>
                                    )}
                                    <td className="px-5 py-5 text-base font-bold text-zinc-500 text-right whitespace-nowrap">
                                        {formatDbDateWithoutTime(order?.created_at)}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={user?.role !== "PM" ? 7 : 6} className="px-4 py-8 text-center text-sm text-zinc-500 font-medium whitespace-nowrap">
                                    No Record Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Orders
